/**
 * Permission groups for common roles
 * Maps team member role IDs to permission sets
 */
export const TEAM_PERMISSIONS = {
   CAN_MANAGE_TEAM: "canManageTeam",
   CAN_INVITE_MEMBERS: "canInviteMembers",
   CAN_MANAGE_PROJECTS: "canManageProjects",
   CAN_VIEW_PROJECTS: "canViewProjects",
   CAN_CREATE_PROJECTS: "canCreateProjects",
   CAN_VIEW_FINANCIALS: "canViewFinancials",
   CAN_MANAGE_BILLING: "canManageBilling",
   CAN_MANAGE_SETTINGS: "canManageSettings",
   CAN_VIEW_SENSITIVE_DATA: "canViewSensitiveData",
};